<template>
  <div class="navbar yhc-bgc-white">
    <div></div>
    <!-- <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" /> -->

    <div class="right-menu">
      <el-button type="text" @click="logout">退出登录</el-button>
      <!-- <el-button type="primary" @click="huanfu">换肤(未完成)</el-button> -->
      <!-- <img src="https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png" class="user-avatar" /> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { baseUrlFull } from '@/ajax/baseUrl';
import { userInfoStorage, authorizationStorage, xTokenStorage } from '@/storages/sessionStorage';
import { menuRightsStorage } from '@/storages/localStorage';
import { clearLegacyBackofficeSession } from '@/features/auth/wecomSessionBootstrap.mjs';

import Hamburger from './Hamburger';

export default {
  components: {
    Hamburger,
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
  },
  methods: {
    async logout() {
      const profile = userInfoStorage.get();
      try {
        if (profile && profile.authenticationMethod === 'wecom') {
          await axios.post(`${baseUrlFull}/backoffice/auth/logout`, null, { withCredentials: true });
        }
      } finally {
        clearLegacyBackofficeSession({
          userInfoStorage,
          authorizationStorage,
          menuRightsStorage,
          xTokenStorage,
        });
        window.location.reload();
      }
    },
    toggleSideBar() {
      this.$store.commit('app/toggleSidebar');
    },
    huanfu() {
      let htmlDom = document.documentElement;

      htmlDom.classList.add('all-transition-global');
      setTimeout(() => {
        htmlDom.classList.remove('all-transition-global');
      }, 500);

      let flag = htmlDom.classList.contains('light');
      if (flag) {
        htmlDom.classList.remove('light');
        htmlDom.classList.add('dark');
      } else {
        htmlDom.classList.remove('dark');
        htmlDom.classList.add('light');
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 1px 4px var(--yhc-color-opacity-dark-1);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .hamburger-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    cursor: pointer;
  }

  .right-menu {
    padding-right: 24px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .m-view {
      margin-right: 24px;
      font-size: 12px;
      font-weight: bold;
      cursor: pointer;
      color: #47a1bb;
    }
    .user-avatar {
      cursor: pointer;
      width: 40px;
      height: 40px;
    }
  }
}
</style>
